/**
 * FR8BOT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const LoadProgress = {
    Saved: 'SAVED',
    Scheduled: 'SCHEDULED',
    NoRate: 'NO_RATE',
    Rate: 'RATE',
    Booked: 'BOOKED',
    OnRoute: 'ON_ROUTE',
    OnStop: 'ON_STOP',
    NoPaymentRequired: 'NO_PAYMENT_REQUIRED',
    PaymentWaiting: 'PAYMENT_WAITING',
    PaymentSent: 'PAYMENT_SENT',
    PaymentConfirmed: 'PAYMENT_CONFIRMED',
    CancelRequested: 'CANCEL_REQUESTED'
} as const;
export type LoadProgress = typeof LoadProgress[keyof typeof LoadProgress];

